import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const MosaferatiPaths: IPaths = {
  BimehNameh: {
    Estelam: '/Mosaferati/Estelam',
    List: '/Mosaferati/List',
    Sodoor: '/Mosaferati/Sodoor',
    Detail: '/Mosaferati/Detail',
    ElhaghiyehSaderehDetail: '/Mosaferati/ElhaghiyehSaderehDetail',
    ElhaghiyehHayeSadereh: '/Mosaferati/ElhaghiyehHayeSadereh',
  },
};
